<template>
  <article
    v-if="currentPage && currentPage.protection.locked === false"
    class="single-page archive-sponsors"
    id="sponsors-page"
  >
    <PageHeader />
    <FilteredPostsList
      taxonomy="sponsors_cat"
      postType="sponsors"
      filters
      key="sponsors_cat"
    />
  </article>
  <PassProtected
    v-else-if="currentPage && currentPage.protection.locked === true"
  >
  </PassProtected>
</template>

<script>
import FilteredPostsList from "@/components/blocks/FilteredPostsList";

export default {
  name: "archive-sponsors",
  components: {
    FilteredPostsList
  }
};
</script>
